import api from './api';

export const transportAPI = {

    getAllTransportSlabs: () => api.get('/transport/get-all-transport-slabs',),
    addTransport: (studentId, transportSlabId ) => api.post(`/transport/assign-transport`, studentId, transportSlabId ),
    updateTransport: (transportId, transportData) => api.post(`/transport/update-transport/${transportId}`, transportData),

};